module.exports = __webpack_public_path__ + "img/num_13.b0e87fe4.png";